export const styles = {
    dashboardContainer: {
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      minHeight: '100vh',
      padding: '1.5rem 0',
    },
    dashboardHeader: {
      background: 'linear-gradient(135deg, rgb(253,126,20), rgb(255,107,69))',
      color: 'white',
      borderRadius: '16px',
      padding: '1.5rem 2rem',
      marginBottom: '1.5rem',
      boxShadow: '0 10px 40px rgba(30, 58, 95, 0.3)',
    },
    filterCard: {
      background: 'white',
      border: 'none',
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
      overflow: 'hidden',
    },
    statCard: {
      background: 'white',
      border: 'none',
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      overflow: 'hidden',
      position: 'relative',
    },
    statCardPrimary: { borderTop: '4px solid #3b82f6' },
    statCardSuccess: { borderTop: '4px solid #10b981' },
    statCardInfo: { borderTop: '4px solid #06b6d4' },
    statCardWarning: { borderTop: '4px solid #f59e0b' },
    statIcon: {
      width: '56px',
      height: '56px',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1rem',
    },
    statIconPrimary: { background: 'rgba(59, 130, 246, 0.1)' },
    statIconSuccess: { background: 'rgba(16, 185, 129, 0.1)' },
    statIconInfo: { background: 'rgba(6, 182, 212, 0.1)' },
    statIconWarning: { background: 'rgba(245, 158, 11, 0.1)' },
    statValue: {
      fontSize: '2rem',
      fontWeight: '700',
      color: '#1e293b',
      lineHeight: '1.2',
      marginBottom: '0.5rem',
    },
    statLabel: {
      fontSize: '0.75rem',
      fontWeight: '600',
      color: '#64748b',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      opacity: 0.7,
    },
    analyticsCard: {
      background: 'white',
      border: 'none',
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
      overflow: 'hidden',
    },
    formControlEnhanced: {
      border: '2px solid #e2e8f0',
      borderRadius: '10px',
      padding: '0.65rem 1rem',
      transition: 'all 0.2s ease',
      fontSize: '0.95rem',
    },
    btnPrimaryEnhanced: {
      background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
      border: 'none',
      borderRadius: '10px',
      padding: '0.65rem 1.25rem',
      fontWeight: '600',
      boxShadow: '0 4px 15px rgba(59, 130, 246, 0.3)',
    },
    btnOutlineEnhanced: {
      border: '2px solid #e2e8f0',
      borderRadius: '10px',
      padding: '0.65rem 1.25rem',
      fontWeight: '600',
      color: '#64748b',
      background: 'white',
    },
    filterSummaryCard: {
      background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
      border: '1px solid #bae6fd',
      borderRadius: '12px',
      padding: '1rem 1.5rem',
    },
    badgeEnhanced: {
      padding: '0.5em 0.85em',
      fontWeight: '500',
      borderRadius: '6px',
      fontSize: '0.75rem',
    },
    badgeExcellent: { background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: 'white' },
    badgeGood: { background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', color: 'white' },
    badgeAverage: { background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: 'white' },
    badgePoor: { background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', color: 'white' },
    loadingContainer: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    },
    tableEnhanced: {
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    trainerCard: {
      background: 'linear-gradient(135deg, #fefce8 0%, #fef3c7 100%)',
      border: '1px solid #fde047',
      borderRadius: '16px',
    },
    emptyState: {
      background: 'linear-gradient(135deg, #f5f7ff 0%, #fff 100%)',
      borderRadius: '20px',
      padding: '4rem 2rem',
      textAlign: 'center',
      border: '2px dashed rgba(102, 126, 234, 0.2)',
    },
    emptyStateIcon: {
      width: '80px',
      height: '80px',
      borderRadius: '20px',
      background: 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1.5rem',
    },
    modalHeader: {
      background: 'linear-gradient(135deg, rgb(253,126,20), rgb(255,107,69))',
      color: 'white',
      borderBottom: 'none',
      borderRadius: '16px 16px 0 0',
      padding: '1.5rem 2rem',
    },
    attendanceBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '4px 8px',
      borderRadius: '6px',
      fontSize: '12px',
      fontWeight: '500',
    },
    presentBadge: {
      backgroundColor: 'rgba(16, 185, 129, 0.15)',
      color: '#059669',
      border: '1px solid rgba(16, 185, 129, 0.3)',
    },
    absentBadge: {
      background: 'rgba(239, 68, 68, 0.1)',
      color: '#dc2626',
      border: '1px solid rgba(239, 68, 68, 0.3)',
    },
    dateCard: {
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      border: '1px solid #e2e8f0',
      borderRadius: '12px',
      padding: '1rem',
      marginBottom: '1rem',
    },

    modalBody: {
      background: 'linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%)',
      padding: 0,
    },
    modalFooter: {
      background: '#f8f9ff',
      borderTop: '1px solid rgba(102, 126, 234, 0.1)',
      padding: '1rem 2rem',
    },
    summaryCard: {
      border: 'none',
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(102, 126, 234, 0.12)',
      overflow: 'hidden',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    },
    summaryCardHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 30px rgba(102, 126, 234, 0.18)',
    },
    statBox: {
      background: 'linear-gradient(135deg, #f5f7ff 0%, #ffffff 100%)',
      borderRadius: '12px',
      padding: '1.25rem',
      textAlign: 'center',
      border: '1px solid rgba(102, 126, 234, 0.1)',
      transition: 'all 0.2s ease',
    },

    infoItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.75rem',
      padding: '0.75rem',
      background: '#f8f9ff',
      borderRadius: '10px',
      marginBottom: '0.5rem',
      border: '1px solid rgba(102, 126, 234, 0.08)',
    },
    infoIcon: {
      width: '36px',
      height: '36px',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    accordionHeader: {
      background: 'transparent',
      border: 'none',
      padding: '1rem 1.25rem',
    },
    lectureCard: {
      border: '1px solid rgba(102, 126, 234, 0.15)',
      borderRadius: '12px',
      marginBottom: '1rem',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
    },
    studentBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '0.35rem 0.75rem',
      borderRadius: '20px',
      fontSize: '0.8rem',
      fontWeight: '500',
      margin: '0.2rem',
      transition: 'transform 0.15s ease',
    },


    dateHeaderBadge: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#fff',
      padding: '0.5rem 1rem',
      borderRadius: '20px',
      fontWeight: '600',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    percentageBadge: {
      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      color: '#fff',
      padding: '0.4rem 0.8rem',
      borderRadius: '8px',
      fontWeight: '700',
      fontSize: '0.9rem',
    },
    exportBtn: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      border: 'none',
      padding: '0.6rem 1.5rem',
      borderRadius: '10px',
      fontWeight: '600',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
      transition: 'all 0.2s ease',
    },
  
  };